// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../shared/Dialog.module.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._aG5UhuzI5Cul8SNFfnP {
    width: max-content;
    transition: opacity 150ms ease;
}

#map-container.gw-map-dragging ._aG5UhuzI5Cul8SNFfnP {
  opacity: 0.85;
}

.c9onuEHJFeu5E_4_hcd7 {
}

.g2CEG4XanKtlmJBsibP8 {
}

.l1ITU2XEQ9Nv4ojkSLTJ {
}

.jlXA_0mxtAwErVmpNCML {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

#gw-map h3.map-heading {
    margin-bottom: 0.25rem;
}

#gw-map p.map-body.kYvM0oCnfmYqoHq6j_5d {
    font-size: var(--map-small-body-font-size);
}`, "",{"version":3,"sources":["webpack://./../core/components/popups/PointPopupContent.module.css"],"names":[],"mappings":"AAAA;IAEI,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;IAEI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":[".popUp {\r\n    composes: container from \"@shared/Dialog.module.css\";\r\n    width: max-content;\r\n    transition: opacity 150ms ease;\r\n}\r\n\r\n:global(#map-container.gw-map-dragging) .popUp {\r\n  opacity: 0.85;\r\n}\r\n\r\n.popUpHeaderContainer {\r\n    composes: headerContainer from \"@shared/Dialog.module.css\";\r\n}\r\n\r\n.popUpHeading {\r\n    composes: headerText from \"@shared/Dialog.module.css\";\r\n}\r\n\r\n.popUpBody {\r\n    composes: contentContainer from \"@shared/Dialog.module.css\";\r\n}\r\n\r\n.popUpBodyContent {\r\n    composes: content from \"@shared/Dialog.module.css\";\r\n    -ms-overflow-style: none;\r\n    scrollbar-width: none;\r\n}\r\n\r\n:global(#gw-map) h3:global(.map-heading) {\r\n    margin-bottom: 0.25rem;\r\n}\r\n\r\n:global(#gw-map) :global(p.map-body).statusMessage {\r\n    font-size: var(--map-small-body-font-size);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popUp": `_aG5UhuzI5Cul8SNFfnP ${___CSS_LOADER_ICSS_IMPORT_0___.locals["container"]}`,
	"popUpHeaderContainer": `c9onuEHJFeu5E_4_hcd7 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["headerContainer"]}`,
	"popUpHeading": `g2CEG4XanKtlmJBsibP8 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["headerText"]}`,
	"popUpBody": `l1ITU2XEQ9Nv4ojkSLTJ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["contentContainer"]}`,
	"popUpBodyContent": `jlXA_0mxtAwErVmpNCML ${___CSS_LOADER_ICSS_IMPORT_0___.locals["content"]}`,
	"statusMessage": `kYvM0oCnfmYqoHq6j_5d`
};
module.exports = ___CSS_LOADER_EXPORT___;
